import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateUserProfileRequest } from '@ghostscreen/contracts';
import { api } from '../api';
import { MY_PROFILE_QUERY_KEY } from './useMyProfile';

/** Every cached query that renders people's names, refreshed after a rename. */
const QUERIES_SHOWING_NAMES = [['org-members'], ['playlist-publish-state'], ['playlist-version']];

export function useUpdateMyProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateUserProfileRequest) => api.updateMyProfile(body),
    onSuccess: async (profile, body) => {
      queryClient.setQueryData(MY_PROFILE_QUERY_KEY, profile);
      if (body.displayName === undefined) return;
      await Promise.all(
        QUERIES_SHOWING_NAMES.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
      );
    },
  });
}
